export const AGENDA_CONDITIONS = {
  REGULAR: 'Regular',
  AFTER_REVIEW_PUBLISHED: '1st 1:1 after review is published',
  AFTER_JOINING_WITHIN_30_DAYS: '1st 1:1 within 30 days of joining',
  AFTER_JOINING_BETWEEN_30_TO_60_DAYS: '1st 1:1 between 30-60 days of joining',
  AFTER_JOINING_BETWEEN_60_TO_90_DAYS: '1st 1:1 between 60-90 days of joining',
};

export type AGENDA_CONDITIONS_TYPE = keyof typeof AGENDA_CONDITIONS;
